import { IconArrowRight, IconPlus } from '@tabler/icons-react';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Table from '../ogComponent/table';
import { Toast } from 'primereact/toast';

export default function LeaveConvert() {
    const [showModal, setShowModal] = useState(false);
    const [monthLeaves, setMonthLeaves] = useState(0);
    const [balanceLeave, setBalanceLeave] = useState(0);
    const [leaveRequests, setLeaveRequests] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        date: new Date().toISOString().split('T')[0],
        change_leave_count: ''
    });
    const navigate = useNavigate();

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const userId = localStorage.getItem('userId');
    const accessToken = localStorage.getItem('accessToken');

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        // setSearchParams({ page: newPage });
    };

    // Fetch leave requests from API
    const fetchLeaveRequests = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/api/leavemanagement/balance-leave-request?employee_id=${userId}`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            // Transform API data to match table structure
            const formattedData = response.data.map((item, index) => {
                // Extract month and year from the month field
                const [year, month] = item.month.split('-');
                // Format the date as DD-MM-YY
                const formattedDate = `${month}-${year.substring(2)}`;

                return {
                    SiNo: index + 1,
                    id: item.id,
                    date: formattedDate,
                    leave_count: item.requested_leaves,
                    status: item.status,
                    // Store original data for reference if needed
                    original: item
                };
            });

            setLeaveRequests(formattedData);
        } catch (error) {
            console.error('Error fetching leave requests:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Fetch Failed',
                detail: "Failed to load leave requests",
                life: 3000,
            });
        }
    };

    // Fetch month leaves for a specific date
    const fetchMonthLeaves = async (selectedDate) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/api/leavemanagement/leave-count-monthly/${userId}/${selectedDate}`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            setMonthLeaves(response.data.total_leave_count);
        } catch (error) {
            console.error('Error fetching month leaves:', error);
        }
    };

    // Fetch balance leave and month leaves on component mount
    useEffect(() => {
        const fetchBalanceLeave = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API}/api/leavemanagement/balance-leave/${userId}`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setBalanceLeave(response.data.balance_leave);
            } catch (error) {
                console.error('Error fetching balance leave:', error);
            }
        };

        fetchBalanceLeave();
        fetchLeaveRequests(); // Fetch leave requests data

        // Also fetch month leaves for the initial date
        fetchMonthLeaves(formData.date);
    }, [userId, accessToken, formData.date]);

    // Handle date change
    const handleDateChange = async (e) => {
        const selectedDate = e.target.value;
        setFormData({ ...formData, date: selectedDate, change_leave_count: '' });

        // Fetch month leaves for the selected date
        fetchMonthLeaves(selectedDate);
    };

    // Handle leave count change with validations
    const handleLeaveChange = (e) => {
        const value = parseInt(e.target.value, 10);

        if (isNaN(value)) {
            setFormData({ ...formData, change_leave_count: '' });
            return;
        }

        // Ensure value is at least 1
        if (value < 1) {
            toast.current.show({
                severity: 'warn',
                summary: 'Number is not Valid',
                detail: "number must be greaterthen 0",
                life: 3000,
            });
            return;
        }

        // Ensure value is not greater than balance leave
        if (value > balanceLeave) {
            toast.current.show({
                severity: 'warn',
                summary: 'Number is not Valid',
                detail: "Cannot exceed your balance leave",
                life: 3000,
            });
            return;
        }

        // Ensure value is not greater than month leaves
        if (value > monthLeaves) {
            toast.current.show({
                severity: 'warn',
                summary: 'Number is not Valid',
                detail: "Cannot exceed the selected month leaves",
                life: 3000,
            });
            return;
        }

        setFormData({ ...formData, change_leave_count: value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            employee_id: userId,
            ...formData
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API}/api/leavemanagement/balance-leave-request/`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            console.log('Success:', response.data);
            toast.current.show({
                severity: 'success',
                summary: 'Request Success',
                detail: "Request send succesfully",
                life: 3000,
            });
            handleClose();

            // Refresh the leave requests data after successful submission
            fetchLeaveRequests();
        } catch (error) {
            console.error('Error:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Request Failed',
                detail: error?.response?.data?.error,
                life: 3000,
            });
        }
    };

    const header = [
        { name: "SiNo", label: "#", active: true },
        { name: "date", label: "Date", active: true },
        { name: "leave_count", label: "Leave Days", active: true },
        { name: "status", label: "Status", active: true }
    ];

    return (
        <div className='px-4 py-3 w-100'>
            <Toast ref={toast} position="bottom-right" />
            <h3 className='mb-3'>My Convert Requests</h3>
            <div className='py-2 d-flex justify-content-between gap-2 flex-wrap'>
                <button className='btn btn-success' style={{ fontSize: "clamp(12px, 1.4vw, 16px)" }} onClick={handleShow}>Leave Convert <IconPlus size={20} /></button>
                <button className='btn btn-primary' style={{ fontSize: "clamp(12px, 1.4vw, 16px)" }} onClick={() => navigate('/user/convertreq')}>Show convert requests <IconArrowRight /></button>
            </div>
            {leaveRequests.length > 0 ?
                <Table
                    product={leaveRequests}
                    header={header}
                    onRowClick={() => { }}
                    currentPage={currentPage}
                    onPageChange={handlePageChange} />
                :
                <div
                    className="d-flex justify-content-center align-items-end position-relative"
                    style={{ height: "50vh" }}
                >
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            backgroundImage: "url(/assets/file.png)",
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            opacity: 0.3,
                        }}
                    ></div>
                    <p className="m-0 fw-light fs-5 position-relative">No Convert Leaves!</p>
                </div>
            }

            {/* Bootstrap Modal */}
            <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="requestPunchModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="requestPunchModalLabel">Request Convert Leave</h5>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className='d-flex flex-column mb-3'>
                                    <label>Your balance leaves</label>
                                    <input type="number" className='form-control' readOnly disabled value={balanceLeave} />
                                </div>
                                <div className='d-flex flex-column mb-3'>
                                    <label>Select Date</label>
                                    <input type="date" className='form-control' value={formData.date} onChange={handleDateChange} required />
                                </div>
                                <div className='d-flex flex-column mb-3'>
                                    <label>Month Leaves</label>
                                    <input type="number" className='form-control' value={monthLeaves} readOnly disabled />
                                </div>
                                <div className='d-flex flex-column mb-3'>
                                    <label>Change Leave Count</label>
                                    <input
                                        type="number"
                                        className='form-control'
                                        value={formData.change_leave_count}
                                        onChange={handleLeaveChange}
                                        min="1"
                                        max={Math.min(balanceLeave, monthLeaves)}
                                        required
                                    />
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && <div className="modal-backdrop fade show" onClick={handleClose}></div>}
        </div>
    );
}